let GenericKeys = {
    // Datapoint-specific data
    status: 'Status',
    eventName: 'EventName',
    throughAFD: 'ThroughAFD',
    tenantGuid: 'TenantGuid',
    serviceVersion: 'ServiceVersion',
    dag: 'Dag',
    forest: 'Forest',
    sessionElapseTime: 'SessionElapseTime',
    sessionOccurences: 'SessionOccurences',
    bootType: 'BootType',
    requestIds: 'RequestIds',
    correlationVectors: 'cV', // this needs to be cV so we can correlate with other databases
    afdId: 'AfdId',
    attemptCount: 'AttemptCount',
    acceptEncoding: 'Accept-Encoding',
    requestContentLength: 'RequestContentLength',
    contentEncoding: 'ContentEncoding',
    responseContentLength: 'ResponseContentLength',
    extraData: 'ExtraData',
    actionSource: 'ActionSource',
    sequenceNumber: 'SequenceNumber',
    cache: 'Cache',

    // Performance metrics
    Waterfall: 'Waterfall',
    UserPerceivedTime: 'UserPerceivedTime',
    e2eTimeElapsed: 'E2ETimeElapsed',
    responseRecieved: 'responseRecieved',
};

let ErrorKeys = {
    errorMsg: 'ErrorMessage',
    errorDetails: 'ErrorDetails',
};

let PropertyBagKeys = {
    // Error property bag
    feServer: 'FEServer',
    beServer: 'BEServer',
    backendStatus: 'BEStatus',
    serverVersion: 'ServerVersion',
    errorRequestsId: 'ErrorRequestId',
    errorMsgId: 'ErrorMessageId',
    errorAFDRef: 'ErrorAFDRef',
    errorReqUrl: 'ErrorRequestUrl',
    errorStatusCode: 'ErrorStatusCode',
    FETimeElapsed: 'FrontEndTimeElapsed',
    BETimeElapsed: 'BackEndTimeElapsed',
};

let ResourceTimingKeys = {
    WorkerStart: 'WorkerStart',
    RedirectStart: 'RedirectStart',
    RedirectEnd: 'RedirectEnd',
    FetchStart: 'FetchStart',
    DomainLookupStart: 'DomainLookupStart',
    DomainLookupEnd: 'DomainLookupEnd',
    ConnectStart: 'ConnectStart',
    SecureConnectionStart: 'SecureConnectionStart',
    ConnectEnd: 'ConnectEnd',
    RequestStart: 'RequestStart',
    ResponseStart: 'ResponseStart',
    ResponseEnd: 'ResponseEnd',
    NextHopProtocol: 'NextHopProtocol',
    Type: 'Type',
};

export { GenericKeys, ErrorKeys, PropertyBagKeys, ResourceTimingKeys };

export const enum DatapointStatus {
    Success = 'Success',
    ServerError = 'ServerError',
    UserError = 'UserError',
    ServerExpectedError = 'ServerExpectedError',
    ClientError = 'ClientError',
    RequestNotComplete = 'RequestNotComplete',
    Timeout = 'Timeout',
    BackgroundSuccess = 'BackgroundSuccess',
}

export interface AnalyticsOptions {
    ariaTenantTokens?: string[];
    isTesting?: boolean; // This will never log any datapoints
    maxErrorsPerSession?: number;
    flightControls?: {
        [index: string]: FlightControl;
    };
    verboseWhiteListEvents?: string[];
}

export interface FlightControl {
    flight: string;
    rate?: number;
}
